<section class="parallax_about">
    <div class="caption">
      <span class="border display-5 fw-bold">About East Indonesia Trip</span>
    </div>
</section>

<div class="container">
    <div class="row mt-5 mb-5">
        <div class="col-md-8">
            <div class="row">
                <div class="col-md-12">
                    <h3 class="fw-bold">Get In Touch</h3>
                    <p>Our team at East Indonesia Trips is committed to ensure you have a great and hassle-free experience with us always. Any questions.</p>
                </div>
            </div>
            <form [formGroup]="pertanyaanForm" (ngSubmit)="onSubmit()">
                <div class="row">
        
                    <div class="col-md-6">
                        <div class="mb-4">
                            <label for="nama" class="form-label">Full Name</label>
                            <input type="text" class="form-control" id="nama" formControlName="nama" placeholder="Full Name">
                        </div>
                    </div>
        
                    <div class="col-md-6">
                        <div class="mb-4">
                            <label for="email" class="form-label">Email <span class="penting">*</span></label>
                            <input type="email" class="form-control" id="email" formControlName="email" placeholder="Email address">
                            <div *ngIf="submitted && pertanyaanForm.controls['email'].invalid" class="text-danger">
                              Email is required
                            </div>
                          </div>
                    </div>
        
                    <div class="col-md-6">
                        <div class="mb-4">
                            <label for="wa" class="form-label">WhatsApp <span class="penting">*</span></label>
                            <input type="text" class="form-control" id="wa" formControlName="wa" #phoneInput>
                            <div *ngIf="submitted && pertanyaanForm.controls['wa'].invalid" class="text-danger">
                              WhatsApp is required
                            </div>
                          </div>
                    </div>
        
                    <div class="col-md-6">
                        <div class="mb-4">
                            <label for="negara" class="form-label">Country <span class="penting">*</span></label>
                            <select id="negara" class="form-control" formControlName="negara">
                              <option value="" disabled selected>Select Country</option>
                              <option *ngFor="let item of data" [value]="item.kode_negara">{{ item.nama_negara }}</option>
                            </select>
                            <div *ngIf="submitted && pertanyaanForm.controls['negara'].invalid" class="text-danger">
                              Country is required
                            </div>
                          </div>
                    </div>
        
                    <div class="col-md-6">
                        <div class="mb-4">
                            <label for="kategori" class="form-label">Trip Category <span class="penting">*</span></label>
                            <select id="kategori" class="form-select" formControlName="kategori">
                              <option value="" disabled selected>-Select-</option>
                              <option value="Boat Charter">Boat Charter</option>
                              <option value="Open Trip Komodo National Park">Open Trip Komodo National Park</option>
                              <option value="Open Trip Raja Ampat">Open Trip Raja Ampat</option>
                            </select>
                            <div *ngIf="submitted && pertanyaanForm.controls['kategori'].invalid" class="text-danger">
                              Trip Category is required
                            </div>
                          </div>
                    </div>
        
                    <div class="col-md-6">
                        <div class="mb-4">
                            <label for="destinasi" class="form-label">Destinations <span class="penting">*</span></label>
                            <select id="destinasi" class="form-select" formControlName="destinasi">
                              <option value="" disabled selected>-Select-</option>
                              <option value="Alor">Alor</option>
                              <option value="Banda Aceh">Banda Aceh</option>
                              <option value="Komodo National Park">Komodo National Park</option>
                              <option value="Raja Ampat">Raja Ampat</option>
                            </select>
                            <div *ngIf="submitted && pertanyaanForm.controls['destinasi'].invalid" class="text-danger">
                              Destinations is required
                            </div>
                          </div>
                    </div>
                    
                    <div class="col-md-6">
                        <div class="form-group mb-4">
                            <label for="startDate">Start Date <span class="penting">*</span></label>
                            <input type="text" class="form-control" id="startDate" formControlName="startDate" (change)="onDateChange('startDate', $event)">
                            <div *ngIf="submitted && pertanyaanForm.controls['startDate'].invalid" class="text-danger">
                              Start Date is required
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group mb-4">
                            <label for="endDate">End Date <span class="penting">*</span></label>
                            <input type="text" class="form-control" id="endDate" formControlName="endDate" (change)="onDateChange('endDate', $event)">
                            <div *ngIf="submitted && pertanyaanForm.controls['endDate'].invalid" class="text-danger">
                              End Date is required
                            </div>
                          </div>
                    </div>
            
              
                  <div class="col-md-12">
                    <div class="form-group mb-4">
                      <label for="inquiry">Your Inquiry</label>
                      <textarea class="form-control" id="inquiry" rows="3" formControlName="inquiry"></textarea>
                    </div>
                  </div>
              
                  <div class="col-md-12">
                    <div class="d-grid gap-2">
                      <button type="submit" class="btn btn-secondary mb-4">Submit Form</button>
                    </div>
                  </div>
                </div>
           </form>
        
        <!-- Pesan Konfirmasi -->
        <div *ngIf="formSubmitted" class="alert alert-secondary" role="alert">
            Thank you for your message. We will get in touch with you shortly.
        </div>
        </div>
        <div class="col-md-4 text-center align-self-center">

            <div class="box-kotak py-5">
                <div class="box-icon">
                    <i aria-hidden="true" class="fas fa-mobile-alt" style="font-size: 32px; padding: 14px;"></i>
                </div>
                <div class="box-konten">
                    <span>
                        Phones
                    </span> 
                    <br>
                    <span>
                        +62 812-3831-0629
                    </span>
                </div>
            </div>
          
            

            <div class="box-kotak py-5">
                <div class="box-icon">
                    <i aria-hidden="true" class="far fa-envelope-open" style="font-size: 32px; padding: 14px;"></i>
                </div>
                <div class="box-konten">
                    <span>
                        Email
                    </span> 
                    <br>
                    <span>
                        info&#64;eastindonesiatrip.com
                    </span>
                </div>
            </div>

                  

            
        </div>
    </div>


</div>

<div class="container-fluid">
    <div class="row bg-white  mt-5">
        <div class="col-md-6">
            <img class="img-lg" src="/assets/img/header-east-1536x1020.png" alt="">
        </div>
        <div class="col-md-6">
            <div class="px-4  my-3">
                <h3 class="fw-bold">Who we are?</h3>
                <p style="text-align: justify;">
                  Established in 2016, East Indonesia Trip began as a travel organizer offering unique journeys to Komodo Island, Sumba, and other hidden gems in East Indonesia. Over the years, with the rising popularity of liveaboard trips, we’ve evolved into a trusted cruise agency specializing in arranging amazing liveaboard experiences. As we’ve grown, we’ve expanded our destinations to Raja Ampat, Alor, and Banda Island. Whether it’s leisure, freediving, or scuba diving, we’re here to craft the perfect adventure for you.
                </p>

                <p style="text-align: justify;">
                  Our team is composed of professional tour guides and photographers, all of whom are certified freedivers. Their expertise ensures not only your safety but also an enriching experience, whether you’re exploring vibrant coral reefs, swimming alongside marine life, or capturing unforgettable moments.
                </p>
                <p style="text-align: justify;">
                  At East Indonesia Trip, we pride ourselves on our commitment to excellence. After every trip, we conduct thorough evaluations to ensure continuous improvement and unmatched service quality. This dedication has earned us the TripAdvisor Travelers' Choice Award for three years in a row since 2022, a testament to the trust and satisfaction of our guests.
                </p>

                <p style="text-align: justify;">
                  In addition to organizing extraordinary trips, we also offer comprehensive boat management services, including operations, marketing, and overall management for liveaboard vessels. Our expertise extends to crafting tailor-made expeditions, research trips, and adventures, reflecting our passion for travel, creativity, and care in every detail.
                </p>

                <p style="text-align: justify;">
                  Whether you’re a first-time traveler or a seasoned explorer, East Indonesia Trip is your gateway to discovering the beauty and wonder of East Indonesia. We are your best way to get around Indonesia’s rich archipelago.
                </p>
            </div>
        </div>
    </div>
</div>


<app-smartch></app-smartch>
<app-review></app-review>
<app-review-b></app-review-b>
<app-footer></app-footer>
